<template>
  <div class="refill-values">
    <icon-button class="close-button safe-top" size="24" icon="el-icon-close" @click.native="$emit('close')" invert></icon-button>
    <div class="amount-block">
      <p class="title">Refill amount</p>
      <div class="value">
        <input
          :readonly="$screen.mobile"
          type="number"
          id="amountId"
          min="50"
          max="5000"
          @keydown="validateNumber"
          v-model="amount"
          @keyup.enter="proceed"
          class="amount-input"
          :class="{ error: error }">
        <p v-if="amount.length === 0" @click="focus('amountId')" :class="{ error: error }">Enter amount</p>
        <span>{{ $root.currency }}</span>
      </div>

      <phone-keyboard class="show-mobile" @input="mobileInput" @backspace="amount = amount.slice(0, -1)" style="margin-top: 50px;" />

      <div class="amount-controls safe-bottom">
        <icon-button icon="arrow-right" size="24" @click.native="proceed" fa invert></icon-button>
      </div>
    </div>

  </div>
</template>

<script>
import PhoneKeyboard from '@/components/shared/PhoneKeyboard'

export default {
  name: 'RefillValues',
  components: { PhoneKeyboard },
  data () {
    return {
      expanded: false,
      amount: '',
      appendedValuta: false,
      error: false
    }
  },
  computed: {
    incrementer () {
      const c = 2
      return ((-80) + 76) / c
    },
    valutaStringLength () {
      return 'DKK'.length + 1
    },
    valuta () {
      return 'DKK' + ' '
    },
    cardMarginTop () {
      return -80
    }
  },
  watch: {
    'amount' (val) {},
    'step' (val) {}
  },
  methods: {
    mobileInput (ev) {
      if (this.amount.length === 0 && ev === '0') {
        return
      }

      this.amount += ev.toString()
    },
    focus (target) {
      document.getElementById(target).focus()
    },
    proceed () {
      if (this.amount.length === 0 || parseInt(this.amount <= 0)) {
        this.error = true
        setTimeout(() => {
          this.error = false
        }, 1100)
        return
      }

      this.$emit('next', {
        amount: this.amount
      })
    },
    onInput () {
      this.$emit('input', this.amount)
    },
    validateNumber (input) {
      if (parseInt(input.target.value + input.key) > 5000) {
        input.preventDefault()
      }
      if (input.key === '+' || input.key === '-' || input.key === ',' || input.key === '.') {
        input.preventDefault()
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      if (this.step === 2) {
        setTimeout(() => {
          document.getElementById('amountId').focus()    
        }, 500)
      }
    })
  },
  mounted () {
    if (document.getElementById('minimumId')) {
      document.getElementById('minimumId').focus()
    }
  }
}
</script>

<style lang="scss" scoped>

  .close-button {
    cursor: pointer;
    position: absolute;
    left: 5px;
    top: 15px;
    z-index: 9999;
  }

  .refill-values {
    background-color: $main;
    height: 100vh;

    @include breakpoint (xs) {
      //height: calc(100vh - 50px);
    }
  }

  .amount-block {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100vh;    
    box-sizing: border-box;
    color: white;
    padding: 20px;

    @include breakpoint (xs) {
      //height: calc(100vh - 50px);
    }

    .amount-controls {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      bottom: 0px;
      left: 0px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 20px 20px 20px 20px;
    }

    .title {
      text-align: center;
      margin: 0;
      font-size: 12px;
      letter-spacing: 1px;
      text-transform: uppercase;
      font-weight: 400;
      padding-bottom: 10px;
    }

    .value {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-bottom: 35px;

      span {
        position: absolute;
        display: inline-block;
        text-align: center;
        width: 100%;
        top: 40px;
        font-size: 12px;
        opacity: 0.7;

        &.currency {
          display: inline-block;
          width: auto;
          top: 3px;
          left: 50%;
          transform: translateX(-100px);
          opacity: 0.2;
          font-weight: 600;
          font-size: 26px;
        }

        &.decimal {
          display: inline-block;
          width: auto;
          top: 3px;
          left: 50%;
          transform: translateX(50px);
          opacity: 0.2;
          font-weight: 600;
          font-size: 26px;
        }
      }

      p {
        font-family: 'Helvetica', sans-serif;
        padding-top: 2.5px;
        top: 0px;
        text-transform: uppercase;
        margin: 0;
        font-size: 26px;
        font-weight: 600;
        text-align: center;
        position: absolute;
        z-index: 99;
        opacity: 0.2;
      }

      .amount-input {
        font-family: 'Helvetica', sans-serif !important;
        position: relative;
        z-index: 999;
        background-color: transparent;
        border: none;
        font-weight: 600;
        font-size: 26px;
        color: white;
        text-align: center;
        padding: 0;

        &:focus {
          outline: none;
        }

        width: 80%;
        // @include breakpoint (xs) {
        // }
      }
    }
  }

  .options-block {
    box-shadow: 0px -2px 6px 0px rgba(0, 0, 0, 0.01);
    padding: 20px;

    h3 {
      font-size: 16px;
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #303133;

      span {
        font-size: 12px;
        cursor: pointer;
      }
    }
  }

  .cards {
    position: relative;
    padding-bottom: 20px;
    overflow: hidden;

    div {
      position: relative;
      z-index: 100;
      transition: all 0.3s ease;

      &:not(:first-child) {
        width: 95%;
        margin: 0 auto;
        margin-top: -48px;
        z-index: 99;
        box-shadow: none;
      }

      &:last-child {
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1) !important;
      }

      &.expanded {
        margin-top: 10px !important;
        width: 100%;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1) !important;
      }
    }
  }

  @keyframes shake
  {
    0% { -webkit-transform: translate(30px); }
    20% { transform: translate(-30px); }
    40% { transform: translate(15px); }
    60% { transform: translate(-15px); }
    80% { transform: translate(8px); }
    100% { transform: translate(0px); }
  }

  .error {
    animation: shake 0.4s 1 linear;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/RefillValues.vue